var map = {
	"./homeIntro_1.png": 677,
	"./homeIntro_2.png": 678,
	"./homeIntro_3.png": 679,
	"./homeIntro_4.png": 680
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 676;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/homeIntro_.*\.png$
// module id = 676
// module chunks = 0